import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

type HelpSectionProps = {
	title: React.ReactNode
	children: React.ReactNode
}

export function HelpSection({ title, children }: HelpSectionProps) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<Card className="w-full p-0 pb-5">
			<button
				type="button"
				className="w-full p-5 pb-0 text-left hover:scale-105 transition-all duration-300"
				onClick={() => {
					setIsOpen((prev) => !prev)
				}}
				aria-expanded={isOpen}
			>
				<CardHeader>
					<CardTitle className="flex items-center justify-between">
						{title}

						{isOpen ? <ChevronUp className="size-5" /> : <ChevronDown className="size-5" />}
					</CardTitle>
				</CardHeader>
			</button>

			{isOpen ? <CardContent>{children}</CardContent> : null}
		</Card>
	)
}
